/* istanbul ignore file */

import { Placement } from '@noths/polaris-client-ribbons-design-system';
import { useRichRelevance } from '@noths/polaris-client-rich-relevance';
import { getProductIdFromProductCode } from '@noths/polaris-client-utils';
import getConfig from 'next/config';

import { requestSimilarProducts } from 'src/redux/richRelevance/thunks';
import { AppThunkDispatch, getStore } from 'src/redux/store';
import { NextConfig } from 'src/types';

const { publicRuntimeConfig } = getConfig() as NextConfig;

export const useAddToCartPlacement = (
  richRelevanceSessionId: string | undefined,
  code: number,
  isModalOpen: boolean,
) => {
  const { dispatch } = getStore();

  useRichRelevance(
    {
      API_KEY: publicRuntimeConfig.RICH_RELEVANCE_API_KEY,
      endpoint: publicRuntimeConfig.endpoints.richRelevance,
      sessionId: richRelevanceSessionId,
    },
    async (fetchPlacement, clearPlacement) => {
      window.R3_COMMON.addPlacementType(Placement.AddToCart);
      window.R3_ADDTOCART = new window.r3_addtocart();
      window.R3_ADDTOCART.addItemIdToCart(String(getProductIdFromProductCode(code)));

      await fetchPlacement();
      const placement = window.RR?.data?.JSON?.placements?.[0];

      if (placement) {
        (dispatch as AppThunkDispatch)(requestSimilarProducts(placement));
      }
      clearPlacement();
    },
    isModalOpen,
  );
};
